<template>
    <div class="transfer-banner">
        <div class="transfer-banner-illustration">
            <Illustration :data="{ type: 'Transfer1' }" />
        </div>
        <div class="transfer-banner-content">
            <ButtonLink size="m" :bold="true" :onClick="toggleModal">
                {{ t({ key: 'shared.do_you_need_transfer' }) }}
            </ButtonLink>
        </div>
    </div>

    <Modal
        v-if="showModal"
        :onClose="toggleModal"
        :title="t({ key: 'shared.do_you_need_transfer' })">
        <p class="transfer-banner-description">
            {{ t({ key: 'shared.you_can_easily_add_transfer' }) }}
        </p>
    </Modal>
</template>

<script lang="ts">
    import { defineComponent, onMounted, computed, ref } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { Cart } from '@/api/Cart/cart.interfaces';
    import {
        logStatsigCheckoutTransferBanner,
        logStatsigCheckoutTransferBannerOpen,
    } from '@/tracking/statsig/checkout.functions';
    import Illustration from '@ui/components/Illustration/Illustration.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';
    import Modal from '@ui/components/Modal/Modal.vue';

    export default defineComponent({
        name: 'TransferBanner',
        methods: { t },
        components: { Illustration, ButtonLink, Modal },
        setup() {
            const store = useStore();
            const cart = computed((): Cart => store.state.cart.data);

            const showModal = ref<boolean>(false);

            onMounted(() => logStatsigCheckoutTransferBanner(cart.value));

            function toggleModal() {
                showModal.value = !showModal.value;

                if (showModal.value) {
                    logStatsigCheckoutTransferBannerOpen(cart.value);
                }
            }

            return { showModal, toggleModal };
        },
    });
</script>

<style lang="scss">
    @forward 'Banner';
</style>
